// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiBaseUrl:  'https://api.mockshala.com', //prod
  apiBaseUrl: 'https://apidev.mockshala.com', //dev
  // apiBaseUrl: 'http://localhost:5002', //dev
  // mediaBaseUrl: 'https://mockshala.s3.ap-south-1.amazonaws.com/'
  mediaBaseUrl: 'https://mockshala-dev.s3.ap-south-1.amazonaws.com/', // dev
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
